import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sdFeatherIcons = _resolveComponent("sdFeatherIcons")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_sdDropdown = _resolveComponent("sdDropdown")!
  const _component_CardFrame = _resolveComponent("CardFrame")!
  const _component_sdHeading = _resolveComponent("sdHeading")!

  return (!_ctx.headless)
    ? (_openBlock(), _createBlock(_component_CardFrame, {
        key: 0,
        size: _ctx.size,
        title: _ctx.title,
        "body-style": _ctx.bodyStyle && _ctx.bodyStyle,
        "head-style": _ctx.headStyle && _ctx.headStyle,
        bordered: _ctx.border,
        bodypadding: _ctx.bodypadding && _ctx.bodypadding,
        style: { width: '100%' }
      }, {
        title: _withCtx(() => [
          _renderSlot(_ctx.$slots, "title")
        ]),
        extra: _withCtx(() => [
          (_ctx.more)
            ? (_openBlock(), _createBlock(_component_sdDropdown, {
                key: 0,
                action: ['click'],
                placement: "bottomRight"
              }, {
                overlay: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "more")
                ]),
                default: _withCtx(() => [
                  (!_ctx.moreText)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "#"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_sdFeatherIcons, {
                            type: "more-horizontal",
                            size: "24"
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: "#"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" More ")
                        ]),
                        _: 1
                      }))
                ]),
                _: 3
              }))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "button")
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "caption"),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["size", "title", "body-style", "head-style", "bordered", "bodypadding"]))
    : (_openBlock(), _createBlock(_component_CardFrame, {
        key: 1,
        bodypadding: _ctx.bodypadding && _ctx.bodypadding,
        "body-style": _ctx.bodyStyle && _ctx.bodyStyle,
        size: _ctx.size,
        style: { width: '100%' },
        bordered: _ctx.border
      }, {
        title: _withCtx(() => [
          _renderSlot(_ctx.$slots, "title")
        ]),
        default: _withCtx(() => [
          (_ctx.title)
            ? (_openBlock(), _createBlock(_component_sdHeading, {
                key: 0,
                as: "h4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.caption)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.caption), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["bodypadding", "body-style", "size", "bordered"]))
}